import React, {useEffect, useMemo, useState} from 'react'

// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadIcon from '@mui/icons-material/Download';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
// import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

// import Grid from '@mui/material/Grid';
// import AttachFileIcon from '@mui/icons-material/AttachFile';

// import {getStoreFileName} from 'ultra/helpers/storage';
import {isFile} from 'ultra/helpers/utils';
import {revertPath} from 'ultra/helpers/route';
import {transliterate} from 'ultra/helpers/utils';
// import {ignoreTextFieldKeys} from "ultra/helpers/utils";
import {isEmptyObj} from 'ultra/helpers/utils';

import {useToasterStore} from '../../../Stores/toster';
// import {useBackdropPreloaderStore} from '../../../Stores/backdropPreloader';

import UploadImage from '../UploadImage';
import Instagram from '../Instagram';

import {getInstaLogo} from '../../../Helpers/utils';

import {useFormStore} from '../../../Stores/form';

import ContentImage from '../../../Modules/Content/Widgets/ContentImage';
import ButtonWithPreloader from '../ButtonWithPreloader'

// import AdaptiveDialog from '../../Adaptive/Dialog';

import './index.scss';

export default function LogoUploader(props) {
    const {content, disabled, field, isEditMode, onBlur, onChange} = props;  // showErrorText
    // console.log(content)
    const {showError} = useToasterStore(); // showSuccess

    const {formVisibleErrors, clearVisibleError} = useFormStore();    
    const showErrorText = formVisibleErrors[field.id];

    // const inputRef = useRef(null);
    // const hiddenImagesRef = useRef(null);

    // const {hideBackdropPreloader} = useBackdropPreloaderStore();
    // const {toaster, showPromt, closeToaster} = useToasterStore();

    // const [name, setName] = useState('')
    // const [img, setImg] = useState(null)
    // const [imgAvailable, setImgAvailable] = useState(false)

    // const [filesUploader, setFilesUploader] = useState();
    // const [selectedUploader, setSelectedUploader] = useState();
    // const [content[field.id], setInstagramLogoPath] = useState();

    const [fileContent, setFileContent] = useState({});
    // const [instagramAccount, setInstagramAccount] = useState('');
    const [fileType, setFileType] = useState();
    const [img, setImg] = useState(null)

    const [delay, setDelay] = useState();
    // const [valueWasChanged, setValueWasChanged] = React.useState(false);

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])
    // console.log(isDisabled)
    const [placeholder] = useState(field.placeholder ? field.placeholder + (field.required ? ' *' : '') : undefined)

    const [instagramFileContent, setInstagramFileContent] = useState({});
    const [instagramFieldChanged, setInstagramFieldChanged] = useState(false);
    const [instagramAccountInProgress, setInstagramAccountInProgress] = useState();

    const className = useMemo(() => {
        let result = "LogoUploader";
        result += isDisabled ? ' disabled' : ''
        result += (showErrorText) ? ' error' : ''
        // valueWasChanged
        return result;
    }, [isDisabled, showErrorText])

    // const [sizeInfo, setSizeInfo] = useState(null);
    // const [textFieldClassName, setTextFieldClassName] = useState()
    // const [actionClassName, setActionClassName] = useState(showErrorText ? 'action error' : 'action')

    // useEffect(() => {
    //     if (field?.options?.size) {
    //         setSizeInfo(`Рекомендовані розміри - ${field?.options?.size.width} x ${field?.options?.size.height}`)
    //     }

    //     setTextFieldClassName(getTextFieldClassName());
    // }, [])

    useEffect(() => {
        if (field?.id) setInstagramFileContent({[field.id]: null});
    }, [field?.id])

    useEffect(() => {
        const value = content[field.id];

        if (isFile(value)) {
            // file
            setImg(URL.createObjectURL(value))
        } else if (value && typeof value === 'string') {
            // string
            setImg(value)
        } else {
            setImg(null)
        }

        setFileContent({[field.id]: value})

    }, [content[field.id]])

    // useEffect(() => {
    //     setTextFieldClassName(getTextFieldClassName());
    //     setActionClassName(showErrorText ? 'action error' : 'action')
    // }, [showErrorText])

    // const getTextFieldClassName = () => {
    //     let textFieldClassName = isDisabled ? 'filesList' : 'filesList emulateEnabled';
    //     textFieldClassName += showErrorText ? ' error' : ''
    //     return textFieldClassName
    // }

    const cleanValue = () => {
        onChange(null);

        // TODO
        // unblur field

        // TODO: ON CANCEL
        // getInstaLogo(instagramAccount)
        //     .controller
    }

    const onInstagramFieldChange = (e) => {
        // setInstagramAccount(e.target.value);
        setInstagramFieldChanged(false);
        // setValueWasChanged(true)
        setInstagramFileContent({[field.id]: e.target.value})
        // TODO: enable button only after 3 symbols in name

        if (showErrorText) clearVisibleError(field.id)
    }

    const onInstagramFieldBlur = (e) => {        
        setDelay(setTimeout(() => {
            onBlur({target: {value: content[field.id]}});
        }, 200))
        
        if (instagramFileContent[field.id]) setInstagramFieldChanged(true);
    }

    const getInstagramLogo = () => {
        clearDelay()
        setInstagramAccountInProgress(true)

        let acc = instagramFileContent[field.id];
        if (acc.includes('instagram.com/')) {
            const parts = acc.split('instagram.com/');
            if (parts[1]) {
                acc = parts[1]?.split('/')[0];
                acc = acc?.split('?')[0];
            }
        }

        if (!acc) {
            showError({snackbarMessage: 'Потрібно вказати instagram аккаунт'})
            return;
        }

        // console.log(content.title);
        if (content) {
            getInstaLogo(acc, content._did, field.id, content._type, revertPath(content._parent + '/' + (transliterate(content.title) || content[field.id])))
                // .promise
                .then(result => {
                    setInstagramAccountInProgress(false)
                    if (result?.[field.id]) {
                        onChange({target: {value: result[field.id]}})
                    }
                })
                .catch(e => {
                    setInstagramAccountInProgress(false)
                    showError({snackbarMessage: e.message})
                })
        }
    }

    const handleTypeChange = (event) => {
        if (fileContent.logo || instagramFileContent.logo) {
            cleanValue();
            setInstagramFileContent({[field.id]: ""});
            // setInstagramAccount('');
        }

        setFileType(event.target.value);
    };

    const clearDelay = () => {
        if (delay) clearTimeout(delay);
    }

    const handleTypeBlur = () => {
        if (!fileType) {
            onBlur({target: {value: content[field.id]}});
        }
        else {
            setDelay(setTimeout(() => {
                onBlur({target: {value: content[field.id]}});
            }, 200))
        }
    }

    const onFileChange = (e) => {
        // setValueWasChanged(true);
        setFileContent({[field.id]: img});
        onChange(e);
    }

    const onFileBlur = (e) => {
        // setDelay(setTimeout(() => {
        // onBlur({target: {value: content[field.id]}});
    }

    const instagramFieldConfig = {id: field.id}

    const uploadFieldConfig = {
        id: field.id,
        placeholder: "Обрати файл"
    }
    if (field?.options?.size) {
        uploadFieldConfig.options = {}
        uploadFieldConfig.options.size = field.options.size
    }

    // const onKeyDownHandler = (e) => {
    //     const regex = new RegExp('^[A-Za-z\-\—\⸺\_\/\:]*$'); // const regex = new RegExp('^[A-Za-z\-\—\⸺\_\/\: ]*$');

    //     if (ignoreTextFieldKeys(e) && !regex.test(e.key)) {
    //         e.preventDefault();
    //         // setRegexpHighlight(true);
    //     }
    //     else {
    //         // setValueWasChanged(true);
    //         // setRegexpHighlight(false);
    //     }
    // }

    // const onBlurDownHandler = (e) => {
    //     onBlur(e);
    //     // setValueWasChanged(true);
    // }
    // console.log(isDisabled, instagramAccountInProgress, content[field.id])
    return <div className={className}>

        <div className='pseudoButton'>
            <div className='select'>
                <FormLabel>{placeholder}:</FormLabel>
                <RadioGroup row onChange={handleTypeChange} onBlur={handleTypeBlur} onFocus={clearDelay}>
                    <FormControlLabel value="instagram" control={<Radio />} label="З Інстаграму" disabled={Boolean(isDisabled || instagramAccountInProgress || !isEmptyObj(content[field.id]))}/>
                    <FormControlLabel value="file" control={<Radio />} label="Файл" disabled={Boolean(isDisabled || instagramAccountInProgress || !isEmptyObj(content[field.id]))}/>
                </RadioGroup>
            </div>

            <Collapse in={fileType === 'instagram'}>
                <div className='inputs instagram'>
                    <div className='wrapper'>
                        <Instagram
                            // value={instagramAccount}
                            // label="Instagram аккаунт"
                            field={instagramFieldConfig}
                            content={instagramFileContent}
                            onChange={onInstagramFieldChange}
                            onBlur={onInstagramFieldBlur}
                            onFocus={clearDelay}
                            // onKeyDown={onKeyDownHandler}
                            // onBlur={onBlurDownHandler}
                            // disabled={Boolean(instagramAccountInProgress || content[field.id])} // isDisabled || 
                            hideErrors={true}
                        />
                        {/* <TextField
                            fullWidth
                            value={instagramAccount}    
                            label="Instagram аккаунт"
                            variant="outlined"
                            error={showErrorText}
                            onChange={onInstagramFieldChange}
                            onKeyDown={onKeyDownHandler}
                            onBlur={onBlurDownHandler}
                            disabled={Boolean(instagramAccountInProgress || content[field.id])} // isDisabled || 
                            // required={field?.required}
                            // error={Boolean(showErrorText)}
                            // helperText={showErrorText}
                            // onKeyDown={onKeyDownHandler}
                            // InputProps={{maxLength: field?.options?.maxLength}}
                        /> */}

                        <ButtonWithPreloader
                            variant="contained"
                            component="label"
                            tabIndex={-1}
                            fullWidth
                            disabled={Boolean(!instagramFileContent[field.id] || instagramFileContent[field.id].length === 0 || content[field.id])}
                            onClick={getInstagramLogo}
                            inprogress={instagramAccountInProgress?.toString() || 'false'}
                        >
                            <DownloadIcon />
                        </ButtonWithPreloader>
                    </div>

                    {!img && <div className="fieldNotes">
                        {instagramFieldChanged && <p className='button'>Натисніть кнопку <DownloadIcon /> для завантаження логотипу</p>}
                        {instagramAccountInProgress && <p className='timer'><b>УВАГА!:</b> Завантаження може зайняти до 30 секунд</p>}
                    </div>}
                </div>
            </Collapse>

            {fileType === 'file' && <div className='inputs file'>
                <UploadImage
                    field={uploadFieldConfig}
                    content={fileContent}
                    onChange={onFileChange}
                    onBlur={onFileBlur}
                    onFocus={clearDelay}
                    hidePreview
                    hideErrors={true}
                />
            </div>}

            {img && <div className='photoWrap'>
                <div className='photoWrapInner'>
                    {!isFile(img) && <ContentImage src="thumbnail" image={img} className="photo" />}
                    {isFile(img) && <img loading="lazy" src={img} className="photo" />}

                    <span className='close' onClick={cleanValue}>
                        <ClearIcon />
                    </span>
                </div>
            </div>}
        </div>

        {!showErrorText && field?.notes && <div className='fieldNotes'>
            <p>{field?.notes}</p>
        </div>}
        {showErrorText && <div className='fieldError'>
            {showErrorText}
        </div>}
    </div>
}
